// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Eo-z","breadcrumbForward":"Fo-z","breadcrumbBack":"Go-z","selected":"Ho-z"};